import * as core from '../../../../../../../core'

import { query } from './stakeholders-by-understanding.query'

export const RESOURCE = {
  payload: {
    alias: 'stakeholders.by.understanding',
    description: 'Chart view of stakeholders by understanding',
    name: 'Stakeholders by Understanding',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
